import { images } from "../constants";

const home = [
    { 
        id: 1,
        image: images.home1,
        subtitle: "Welcome to Primecars",
        headingPart1: "Find Your",
        spanText: "Dream Car",
        headingPart2: "with Us",
        description: "Explore a vast collection of new and pre-owned cars tailored to meet your driving needs and budget.",
        buttonText: "Explore More",
        buttonLink: 'About-us'
    },
    {
        id: 2,
        image: images.home2,
        subtitle: "Welcome to Primecars",
        headingPart1: "Quality",
        spanText: "Car Services",
        headingPart2: "You Can Trust",
        description: "From sales to after-sales services, we provide everything to make your car ownership experience seamless.",
        buttonText: "Learn More",
        buttonLink: 'About-us'
    },
    {
        id: 3,
        image: images.home3,
        subtitle: "Welcome to Primecars",
        headingPart1: "Drive",
        spanText: "Luxury",
        headingPart2: "with Premium Cars",
        description: "Upgrade your lifestyle with our exclusive selection of luxury vehicles at unbeatable prices.",
        buttonText: "Discover More",
        buttonLink: 'About-us'
    },
];

export default home;